import { useState, useEffect, useRef } from 'react';

interface Size {
    width: number;
    height: number;
}

const useComponentSize = () => {
    const ref = useRef<HTMLDivElement>(null);
    const [size, setSize] = useState<Size>({ width: 0, height: 0 });

    useEffect(() => {
        const handleResize = (entries: ResizeObserverEntry[]) => {
            if (!Array.isArray(entries)) {
                return;
            }

            const entry = entries[0];
            if (entry) {
                const { width, height } = entry.contentRect;
                setSize({ width, height });
            }
        };

        const resizeObserver = new ResizeObserver(handleResize);

        if (ref.current) {
            resizeObserver.observe(ref.current);
        }

        return () => {
            if (ref.current) {
                resizeObserver.unobserve(ref.current);
            }
            resizeObserver.disconnect();
        };
    }, [ref]);

    return [ref, size] as const;
};

export default useComponentSize;
